import { PhrasebookWord } from 'models/phrasebook-word';
import {Agent, request} from './base';

export class PhrasebookAgent extends Agent<PhrasebookWord> {
    constructor() {
        super(PhrasebookWord, '/phrasebook');
    }
    getCategories = async (language: string) => {
        return await request.get(`/phrasebook/categories?language=${language}`);
    };
    getCategoryWords = async (unitId: string, language: string) => {
        return await request.get(`/phrasebook/categories/words?unitId=${unitId}&language=${language}`);
    };
    getCategoryByUnitId = async (unitId: string, language: string, defaultTranslation: string, defaultEnTranslation: string) => {
        return await request.get(`/phrasebook/categories/unit?unitId=${unitId}&language=${language}&defaultTranslation=${defaultTranslation}&defaultEnTranslation=${defaultEnTranslation}`);
    };
    getImportedWords = async (unitId: string, language: string) => {
        return await request.get(`/phrasebook/words?unitId=${unitId}&language=${language}`);
    };
    importWord = async (language: string, category: any, word: any) => {
        return await request.post(`/phrasebook/words/import`, {
            language,
            category,
            word
        });
    };
    unImportWord = async (language: string, category: any, word: any) => {
        return await request.post(`/phrasebook/words/unimport`, {
            language,
            category,
            word
        });
    };
    updateWordDescription = async (language: string, category: any, word: any, description?: string, descriptionEn?: string) => {
        return await request.post(`/phrasebook/words/update-description`, {
            language,
            category,
            word,
            description,
            descriptionEn
        });
    };
    saveCategory = async (unitId:string, language:string, fieldLocalized: string, fieldEn: string, description: string, descriptionEn: string) => {
        return await request.post(`/phrasebook/categories`, {
            unitId,
            language,
            text: fieldLocalized,
            textEn: fieldEn,
            description,
            descriptionEn
        });
    };
    syncAll = async () => {
        return await request.post(`/phrasebook/sync`, {
        });
    };
    uploadImage = async (wordId: string, file: any) => {
        let formData = new FormData();
        formData.append('image', file);
        formData.append('wordId', wordId);
        return await request.post(`/phrasebook/words/upload-image`, formData, 'multipart');
    };
}
